import { useT } from "@transifex/react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import StyledButton from "../../../basic/styledButton/StyledButton";
import ResponsiveButton from "../../../basic/responsiveButton/ResponsiveButton";
import { useGeneralContext } from "../../../context/AppGeneralContext";
import { CreationModes } from "../../../constants/CreationFlowConstants";

import CreationFlowSection from "../../../basic/create/creationFlowSection/CreationFlowSection";
import VocabTrainingTitleBar from "../../../complex/create/vocabTrainingTitleBar/VocabTrainingTitleBar";
import BookSelection from "../../../complex/create/bookSelection/BookSelection";
import { isOnLaterBookSelectionStep } from "../../../complex/create/bookSelection/useStepHistory";
import CtasWrapperRT from "../../../wrapper/create/ctasWrapperRT/ctasWrapperRT";

import { Wrapper } from "./StyledComponents";

/** The vocab training's four-step book selection: the "stepper" variant of the book selection experiment. */
const SelectBookStepperRT = () => {
    const { creatingMode, userInfo } = useGeneralContext();

    const t = useT();
    const t_back = t("Back", { _tags: "CreateTest,SelectBook" });

    const history = useHistory();
    const [confirmButtonSlot, setConfirmButtonSlot] = useState<HTMLDivElement | null>(null);

    function handleBackButton() {
        // Steps back through the selection first, like the browser's Back.
        if (creatingMode === CreationModes.RECURRING_TASK && !isOnLaterBookSelectionStep(history.location.state)) {
            history.push("/create/choose-vocab-training-source");
        } else {
            history.goBack();
        }
    }

    return (
        <Wrapper>
            <CreationFlowSection>
                <VocabTrainingTitleBar />
            </CreationFlowSection>
            <div className="rounded-small-container bg-white p-s">
                <BookSelection confirmButtonSlot={confirmButtonSlot} />
            </div>
            {/* Also for anonymous users, who get no back button: the book selection's confirm button lives here. */}
            <CtasWrapperRT isSticky>
                {!userInfo.isAnonymousUser && (
                    <ResponsiveButton
                        onClick={handleBackButton}
                        iconName="chevron-left"
                        label={t_back}
                    >
                        <StyledButton
                            onClick={handleBackButton}
                            arrowDirection={"LEFT"}
                            buttonStyle={"BLANK"}
                        >
                            {t_back}
                        </StyledButton>
                    </ResponsiveButton>
                )}
                <div
                    ref={setConfirmButtonSlot}
                    className="ml-auto flex"
                />
            </CtasWrapperRT>
        </Wrapper>
    );
};

export default SelectBookStepperRT;
